module.exports = __webpack_public_path__ + "static/media/WhitespaceBadOptimized.cd147be6.png";